import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import persistedReducer from '@/redux/reducer/reducer';


const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check for non-serializable values like `axios`
    })
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export default store;
